import { Pipe, PipeTransform } from '@angular/core';

/** "T3 + T4": the tables of one booking, pushed together (FNF-1184). */
export function tableNamesLabel(names: string[] | null | undefined): string {
  return (names ?? []).join(' + ');
}

/**
 * A booking's table names, taken from the restaurant's own table list where it
 * has the table. reservation-service stores a table's id as its name when its
 * own copy of the floor doesn't have that table, which would show a raw id.
 * The stored names are kept when they are real names (an older booking, or a
 * table since removed from the floor).
 */
export function bookingTableNames(
  ids: string[] | null | undefined,
  storedNames: string[] | null | undefined,
  tables: { id: string; name: string }[],
): string[] {
  const stored = storedNames ?? [];
  if (!ids?.length) {
    return stored;
  }
  const byId = new Map(tables.map((t) => [t.id, t.name]));
  const known = ids.map((id) => byId.get(id));
  if (known.every((name) => !!name)) {
    return known as string[];
  }
  if (stored.length && !stored.some((name) => ids.includes(name))) {
    return stored;
  }
  return ids.map((id, i) => known[i] ?? id);
}

@Pipe({
  name: 'tableNames',
  standalone: true,
})
export class TableNamesPipe implements PipeTransform {
  transform(names: string[] | null | undefined): string {
    return tableNamesLabel(names);
  }
}
